jQuery(document).ready(function ($) {
  //
  // VARS & OPTIONS
  //
  navObj = {
    ctn: $('#main-nav'),
    canva: $('.ctn-menu'),
    canvaWidth: '',
    content: $('.menu-content'),
  };

  navDesktopObj = {
    ctn: $('#desktop-menu'),
    width: '',
    widthPrev: '',
  };

  navMobileObj = {
    ctn: $('#mobile-menu'),
  };

  modalObj = {
    ctn: $('.menu-modal'),
    background: $('html'),
    bg: $('.menu-modal-bg'),
    content: $('.menu-modal-content'),
    icon: $('.menu-icon'),
    button: $('.component-menu-trigger'),
    phone: $('.phone-element'),
  };

  // Fade Nav in on scroll top
  fadeObj = {
    fade: true,
    fadeNav: navObj.ctn,
    threshold: 200,
    breakpoint: 0,
    visible: false,
    scrollPrev: $(window).scrollTop(),
  };

  //
  // Events
  //
  
  // Mobile-Button
  $(modalObj.button).click(function(){
    menuToggle(modalObj);
  });

  // Menu-Links für Onepager bzw. Scroll
  $('#desktop-menu .scroll-to a').click(function (event){
    event.preventDefault();
    scrollTo($(this));
  });

  $('#mobile-menu .scroll-to a').click(function (event){
    event.preventDefault();
    scrollTo($(this));
    menuToggle(modalObj);
  });

  $('.blog-content .scroll-to').click(function (event){
    event.preventDefault();
    scrollTo($(this));
  });

  //
  // Functions
  //

  var updateWidths = function(){
    navObj.canvaWidth = navObj.canva.width();
    navDesktopObj.width = navDesktopObj.ctn.width();
  };

  var setNavMode = function(){
    updateWidths();

    // mobil
    if(navObj.canvaWidth <= navDesktopObj.width){
      navDesktopObj.widthPrev = navDesktopObj.width;
      navObj.content.css({'display': 'none', 'opacity': '0'});
      modalObj.icon.css({'display': 'block', 'opacity': '1'});
      navObj.ctn.addClass('is-mobile').removeClass('is-desktop');
    // desktop
    } else if(navObj.canvaWidth > navDesktopObj.width && navObj.canvaWidth > navDesktopObj.widthPrev) {
      navObj.content.css({'display': 'block', 'opacity': '1'});
      modalObj.icon.css({'display': 'none', 'opacity': '0'});
      navObj.ctn.addClass('is-desktop').removeClass('is-mobile');
      // wenn modal sichtbar zurücksetzen
      if(modalObj.ctn.hasClass('is-open')){
        menuToggle(modalObj);
      }
    }
  };

  var scrollTo = function (target) {
    var t = $(target).attr('href');
    var $page = $('html, body');
    $page.on('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove', function () {
      $page.stop();
    });
    $page.animate({
      scrollTop: $('' + t + '').offset().top,
    }, 1000, function () {
        $page.off('scroll mousedown wheel DOMMouseScroll mousewheel keyup touchmove');
      });
    return false;
  };
  
  var menuToggle = function(modalObj){
    modalObj.button.toggleClass('is-open');
    modalObj.ctn.toggleClass('is-open');
    modalObj.background.toggleClass('no-scroll');
    modalObj.phone.toggleClass('is-open');

    modalStateChange(modalObj);
  };

  var modalStateChange = function(modalObj){
    if(modalObj.ctn.hasClass('is-open')){
      modalOpen(modalObj);
    } else {
      modalClose(modalObj);
    }
  };

  var modalOpen = function(modalObj){
    modalObj.bg.css({opacity: 1, visibility: 'visible'});
    modalObj.content.css({opacity: 1, visibility: 'visible'});
    modalObj.ctn.css('z-index', 98);
  };

  var modalClose = function(modalObj){
    modalObj.bg.css({opacity: 0});
      modalObj.content.css({opacity: 0});
      modalObj.ctn.delay(400).queue(function(next){
        modalObj.bg.css({visibility: 'hidden'});
        modalObj.content.css({visibility: 'hidden'});
        modalObj.ctn.css('z-index', -1);
        next();
      });
  };

  // states: is-ontop | is-fixed
  var slideOut = function(){
    fadeObj.visible = false;
    fadeObj.fadeNav.removeClass('is-visible');
    setTimeout(function(){
      if($scroll < fadeObj.threshold){
        fadeObj.fadeNav.removeClass('is-fixed');
      } else {
        fadeObj.fadeNav.removeClass('is-ontop');
      }
    }, 600);
  };

  // states: is-ontop | is-fixed
  var slideIn = function(state){
    fadeObj.visible = true;
    fadeObj.fadeNav.addClass(''+state+' is-visible');
  };

  var initFadeIn = function(){
    navDesktopObj.ctn.css('opacity', 1);
    navMobileObj.ctn.css('opacity', 1);
    modalObj.icon.css('opacity', 1);
  };

  //  
  // Responsive Adjustments
  //
  $(window).resize(function(){
    setNavMode();
  });

  $(window).scroll(function(event){
    if(fadeObj.fade){
      $scroll = $(window).scrollTop();

      // ist oben
      if($scroll < fadeObj.threshold){
        slideIn('is-ontop');
      } 
      // hochscrollen
      else if(fadeObj.scrollPrev > $scroll){
        if( fadeObj.breakpoint == 0 ){
          fadeObj.breakpoint = $scroll;
        } else if($scroll <= (fadeObj.breakpoint - fadeObj.threshold) && fadeObj.visible == false){
          slideIn('is-fixed');
        }
      }
      //zurücksetzen
      else {
        if( fadeObj.breakpoint != 0 && fadeObj.visible == true){
          fadeObj.breakpoint = 0;
          slideOut('is-fixed');
        } else if( fadeObj.fadeNav.hasClass('is-ontop') ){
          if($scroll >= fadeObj.threshold){
            slideOut('is-ontop');
          }
        }
      }

      fadeObj.scrollPrev = $scroll;
    }
  });

  // Init
  navDesktopObj.widthPrev = navDesktopObj.ctn.width();
  setNavMode();
  if($(window).scrollTop() < fadeObj.threshold){
    slideIn('is-ontop');
  }
  
  setTimeout(function(){
    initFadeIn();
    setNavMode();
    fadeObj.fadeNav.css('transition', 'transform .6s');
  }, 400);
  
});